export const figurenames = {
  cylinder: [
    {
      key: "height",
      text: "alto"
    },
    {
      key: "radius",
      text: "radio"
    }
  ],
  tube: [
    {
      key: "height",
      text: "alto"
    },
    {
      key: "radius",
      text: "radio"
    },
    {
      key: "tube",
      text: "tube"
    }
  ],
  torus: [
    {
      key: "radius",
      text: "radio"
    },
    {
      key: "tube",
      text: "tube"
    }
  ],
  rectangle: [
    {
      key: "width",
      text: "ancho"
    },
    {
      key: "height",
      text: "alto"
    },
    {
      key: "length",
      text: "largo"
    }
  ],
  rhomboid: [
    {
      key: "width",
      text: "ancho"
    },
    {
      key: "height",
      text: "alto"
    },
    { key: "depth", text: "profundidad" },
    { key: "angle", text: "angulo" }
  ]
};

export const figures = {
  cylinder: {
    name: "cylinder",
    values: {
      height: 2000,
      radius: 200
    }
  },
  tube: {
    name: "tube",
    values: {
      height: 2000,
      radius: 200,
      tube: 100
    }
  },
  torus: {
    name: "torus",
    values: {
      radius: 600,
      tube: 250
    }
  },
  rectangle: {
    name: "rectangle",
    values: {
      height: 600,
      width: 600,
      length: 1400
    }
  },
  rhomboid: {
    name: "rhomboid",
    values: {
      height: 400,
      width: 800,
      depth: 400,
      angle: 45
    }
  }
};


export const grades = [
  { key: 0, value: 1, name: "Grado#Prueba" },
  { key: 1, value: 2, name: "42CrMo4" },
  { key: 2, value: 3, name: "51CrV4" },
  { key: 3, value: 4, name: "100Cr6" }
];


export const marksAgitation = {
  0: "0",
  1: "0.25",
  2: "0.50",
  3: "0.75"
};